module.exports = __webpack_public_path__ + "static/media/icon_pdf.7001d566.svg";